import React, { useEffect } from "react";
import TeaserComponent from "./TeaserComponent";
import InfiniteScroll from "../../../components/InfiniteScroll";
import {
  GetHeaderState,
  SetHeaderState,
  TeaserListDetailService,
  TeasersService,
  TeasersSummaryStat
} from "../../../utils/api";
import Loader from "../../../ui/Loader/Loader";

import { teaserStatus } from "../../../constants";
import usePrev from "../../../hooks/usePrev";
import useThis from "../../../hooks/useThis";
import useEventEmitter from "../../../hooks/useEventEmitter";
import useNotifications from "../../../hooks/useNotifications";

import { isEqual } from "lodash";

const Teasers = ({
  teasers,
  search,
  page,
  loading,
  hasMore,
  payoutMode,
  checked,
  onCheckChange,
  globalCheck,
  onChange,
  showOt,
  showUrl,
  setTeasersLoading,
  setTeasers,
  setTotalStat,
  appendTeasers,
  setPage,
  setSearch,
  resetTeasersSearch,
  reloadCnt,
  showDisclaimer
}) => {
  const prevSearch = usePrev(search);
  const prevReloadCnt = usePrev(reloadCnt);
  const prevPage = usePrev(page);
  const thisPage = useThis(page);
  const thisLoading = useThis(loading);
  const thisHasMore = useThis(hasMore);
  const eventEmitter = useEventEmitter();
  const notifications = useNotifications();

  const load = (search, page) => {
    if (
      isEqual(search, prevSearch) &&
      page == prevPage &&
      reloadCnt == prevReloadCnt
    ) {
      return;
    }

    setTeasersLoading(true);

    const params = { ...search, page };

    TeasersService(params)
      .then(({ teasers, total_count, total_stat }) => {
        if (page == 1) {
          window.scrollTo(0, 0);
          setTeasers({ teasers, total_count, total_stat });
        } else {
          appendTeasers(teasers);
        }
      })
      .catch(e => {
        console.log(e);
        if (e.code == "BAD_SORT") {
          notifications.showSimpleNotification({
            title: "Данный вид сортировки  недоступен",
            text: "Установлена сортировка по умолчанию",
            color: "red"
          });
          setSearch({ sort_by: "date_add" });
        } else if (e.code == "BAD_FILTER") {
          notifications.showSimpleNotification({
            title: "Данный вид фильтрации  недоступен",
            text: "Установлены фильтры по умолчанию",
            color: "red"
          });
          resetTeasersSearch();
        }
      });
  };

  const loadSummaryStat = filters => {
    /*if (isEqual(search, filters)) {
            return;
        }*/

    TeasersSummaryStat(filters)
      .then(total_stat => {
        setTotalStat({ total_stat });
      })
      .catch(e => {
        console.log(e);
      });
  };

  const onNextLoad = () => {
    if (!thisLoading.current && thisHasMore.current) {
      setTeasersLoading(true);
      setPage(thisPage.current + 1);
    }
  };

  const reloadTeaser = tid => {
    TeaserListDetailService({ tid }).then(teaser => {
      onChange(teaser.id, teaser);
    });
  };

  const hasDisclaimer =
    search.has_disclaimer === "true" || search.has_disclaimer === true;

  useEffect(() => {
    // юзер прокрутил до следующей страницы и поменялся фильтр
    if (search != prevSearch && page != 1) {
      // сбрасываем на первую страницу
      setPage(1);
    } else {
      // изменилась страница или находясь на первой старнице поменялся фильтр
      load(search, page);
    }
  }, [page, search, reloadCnt]);

  useEffect(() => {
    loadSummaryStat(search);
  }, [search]);

  useEffect(() => {
    eventEmitter.subscribe("teaser_update", data => {
      reloadTeaser(data.tid);
    });
  }, []);

  return (
    <InfiniteScroll onNextLoad={onNextLoad}>
      <div className="teaser-list">
        <div className="content-body">
          {teasers.map((teaser, i) => {
            const isChecked = globalCheck || checked.indexOf(teaser.id) != -1;
            const showDivider =
              teasers[i].isNew && teasers[i + 1] && !teasers[i + 1].isNew;

            return (
              <React.Fragment key={i}>
                <TeaserComponent
                  key={i}
                  teaser={teaser}
                  payment={payoutMode}
                  checked={isChecked}
                  onCheckChange={onCheckChange}
                  onChange={onChange}
                  showOt={showOt}
                  showUrl={showUrl}
                  showDisclaimer={showDisclaimer}
                />
                {showDivider && <div className="teaser-list__divider" />}
              </React.Fragment>
            );
          })}
        </div>
      </div>
      {loading && hasMore && <Loader />}
    </InfiniteScroll>
  );
};

export default Teasers;
